import React, { Component, PropTypes } from 'react';
import moment from 'moment';

let $ = window.jQuery;

export default class Calendar extends Component {

    static propTypes = {
        onDayClick: PropTypes.func.isRequired
    };

    initCalendar = () => {
        if (!$.fullCalendar) {
            return;
        }

        var h = {};

        if ($('#calendar').width() <= 400) {
            $('#calendar').addClass("mobile");
            h = {
                left: 'title, prev, next',
                center: '',
                right: 'today,month'
            };
        }

        var self = this;
        $('#calendar').fullCalendar('destroy'); // destroy the calendar
        $('#calendar').fullCalendar({ //re-initialize the calendar
            schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
            disableDragging: false,
            header: h,
            editable: false,
            theme: false,
            height: 100,
            dayClick: function(date, jsEvent, view) {

                // Update appointmentDate global state
                if (! jsEvent.target.classList.contains('fc-past')) {
                    self.props.selectedADate(date.format('MMMM DD, YYYY'));
                } else {
                    self.props.selectedADate(moment().format('MMMM DD, YYYY'));
                }

                $('.fc-day:not(td.fc-today)').html('');

                if ($(this).hasClass('fc-today')) {
                    $(this).html('<span class="dateToday"></span>');
                } else {
                    $(this).html('<span class="dateSelected"></span>');
                }

                self.props.onDayClick(date.format());
            },
            viewRender: (view, e) => {
                self.props.onChangeMonth(view.calendar.getDate().format('YYYY-MM-DD'));

                if (view.calendar.getDate().diff(moment(), 'day') >= 0) {
                    self.props.selectedADate(view.calendar.getDate().format('MMMM DD, YYYY'));
                }

                $('td.fc-day.fc-today').html('<span class="dateToday"></span>');
            }
        });
    };

    componentWillReceiveProps(nextProps) {

        $('.fc-day:not(td.fc-today) .withAppointment').remove();

        nextProps.appointmentDates.forEach((item, i) => {
            let $el = $('td[data-date='+item+'].fc-day:not(td.fc-today)');

            $el.html('<span class="dateSelected withAppointment hasAppointment"></span>');
        });
    }

    componentDidMount() {
        this.initCalendar();
    }

    render() {
        return (
            <div className="col-md-12 col-lg-12 col-sm-12" style={{ height: '80%'}}>
                <div id="calendar" className="has-toolbar"> </div>
            </div>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Calendar/Calendar.js
 **/